// import React from "react";

// const ThermalInvoice = ({ invoiceData, accountData }) => {
//   const handlePrint = () => {
//     const totalGST = (
//       parseFloat(invoiceData?.totalCgst || 0) +
//       parseFloat(invoiceData?.totalSgst || 0) +
//       parseFloat(invoiceData?.totalIgst || 0)
//     ).toFixed(2);

//     const invoiceDate = new Date(invoiceData?.createdAt).toLocaleString();

//     const itemsHTML = invoiceData?.invoicedProducts?.map((product) => {
//       const total = (product.quantity * parseFloat(product.totalUnitPrice)).toFixed(2);
//       return `
//         <div class="item-row">
//           <div class="item-name">${product.product.name}</div>
//           <div class="item-qty">${product.quantity}</div>
//           <div class="item-price">₹${product.totalUnitPrice}</div>
//           <div class="item-total">₹${total}</div>
//         </div>
//       `;
//     }).join("");

//     const htmlContent = `
//       <html>
//         <head>
//           <style>
//             @media print {
//               body {
//                 font-family: monospace;
//                 font-size: 12px;
//                 width: 80mm;
//                 margin: 0;
//                 padding: 0;
//               }
//               .receipt {
//                 width: 80mm;
//                 padding: 4px;
//                 text-align: center;
//               }
//               .title {
//                 font-size: 16px;
//                 font-weight: bold;
//               }
//               .line {
//                 border-top: 1px dashed #000;
//                 margin: 4px 0;
//               }
//               .item-row {
//                 display: flex;
//                 justify-content: space-between;
//                 text-align: left;
//                 font-size: 12px;
//               }
//               .item-name {
//                 flex: 2;
//                 text-align: left;
//               }
//               .item-qty,
//               .item-price,
//               .item-total {
//                 flex: 1;
//                 text-align: right;
//               }
//               .totals {
//                 display: flex;
//                 justify-content: space-between;
//                 font-weight: bold;
//                 margin-top: 4px;
//               }
//               p {
//                 margin: 2px 0;
//               }
//             }
//           </style>
//         </head>
//         <body>
//           <div class="receipt">
//             <div class="title">${accountData?.name?.toUpperCase() || "Company Name"}</div>
//             <p>${accountData?.address || "N/A"}, ${accountData?.city || ""}, ${accountData?.state || ""}, ${accountData?.pincode || ""}</p>
//             <p>Email: ${accountData?.email || "N/A"} | Phone: ${accountData?.mobile || "N/A"}</p>
//             ${invoiceData?.gstNumber ? `<p>GSTIN: ${invoiceData.gstNumber}</p>` : ""}
//             ${accountData?.fssaiNumber ? `<p>FSSAI: ${accountData.fssaiNumber}</p>` : ""}
//             <div class="line"></div>

//             <p><b>Invoice No:</b> ${invoiceData?.code || "N/A"} <br/><b>Date:</b> ${invoiceDate}</p>
//             <p><b>Customer:</b> ${invoiceData?.customerName || "N/A"} <br/><b>Phone:</b> ${invoiceData?.customerPhone || "N/A"}</p>
//             <div class="line"></div>

//             <div class="item-row" style="font-weight:bold;">
//               <div class="item-name">Item</div>
//               <div class="item-qty">Qty</div>
//               <div class="item-price">Rate</div>
//               <div class="item-total">Total</div>
//             </div>
//             <div class="line"></div>
//             ${itemsHTML}
//             <div class="line"></div>

//             <div class="totals"><span>Subtotal:</span><span>₹${invoiceData?.subTotal}</span></div>
//             <div class="totals"><span>GST:</span><span>₹${totalGST}</span></div>
//             <div class="totals"><span>Grand Total:</span><span>₹${invoiceData?.grandTotal}</span></div>
//             <div class="line"></div>

//             <p>Thank you for your purchase!</p>
//           </div>
//           <script>
//             window.onload = () => {
//               window.print();
//             };
//           </script>
//         </body>
//       </html>
//     `;

//     // Convert HTML to a Blob
//     const blob = new Blob([htmlContent], { type: "text/html" });
//     const blobURL = URL.createObjectURL(blob);

//     // Create an invisible iframe to load the receipt
//     const iframe = document.createElement("iframe");
//     iframe.style.display = "none";
//     iframe.src = blobURL;
//     document.body.appendChild(iframe);

//     // Cleanup when print dialog is closed
//     const cleanup = () => {
//       document.body.removeChild(iframe);
//       URL.revokeObjectURL(blobURL);
//       window.removeEventListener("focus", cleanup);
//     };
//     window.addEventListener("focus", cleanup);
//   };

//   return (
//     <button
//       className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 mr-2"
//       type="button"
//       onClick={handlePrint}
//     >
//       Print
//     </button>
//   );
// };

// export default ThermalInvoice;


import React from "react";

const ThermalInvoice = ({ invoiceData, accountData }) => {
  const handlePrint = () => {
    const totalGST = (
      parseFloat(invoiceData?.totalCgst || 0) +
      parseFloat(invoiceData?.totalSgst || 0) +
      parseFloat(invoiceData?.totalIgst || 0)
    ).toFixed(2);

    const invoiceDate = new Date(invoiceData?.createdAt).toLocaleString();

    const itemsHTML = invoiceData?.invoicedProducts?.map((product) => {
      const total = (product.quantity * parseFloat(product.totalUnitPrice)).toFixed(2);
      return `
        <div class="item-row">
          <div class="item-name">${product.product.name}</div>
          <div class="item-qty">${product.quantity}</div>
          <div class="item-price">₹${product.totalUnitPrice}</div>
          <div class="item-total">₹${total}</div>
        </div>
      `;
    }).join("");

    const htmlContent = `
      <html>
        <head>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <style>
            @media print {
              * {
                box-sizing: border-box;
              }
              body {
                font-family: monospace;
                font-size: 11px;
                margin: 0;
                padding: 0;
              }
              .receipt {
                width: 100%;
                max-width: 110mm;
                min-width: 58mm;
                margin: 0 auto;
                text-align: center;
              }
              .title {
                font-size: 14px;
                font-weight: bold;
              }
              .line {
                border-top: 1px dashed #000;
                margin: 4px 0;
              }
              .item-row {
                display: flex;
                justify-content: space-between;
                font-size: 11px;
              }
              .item-name {
                flex: 3;
                text-align: left;
                word-break: break-word;
              }
              .item-qty {
                flex: 1;
                text-align: center;
              }
              .item-price, .item-total {
                flex: 1.5;
                text-align: right;
              }
              .totals {
                display: flex;
                justify-content: space-between;
                font-weight: bold;
                font-size: 12px;
                margin-top: 4px;
              }
              p {
                margin: 2px 0;
              }
            }
          </style>
        </head>
        <body>
          <div class="receipt">
            <div class="title">${accountData?.name?.toUpperCase() || "Company Name"}</div>
            <p>${accountData?.address || "N/A"}, ${accountData?.city || ""}, ${accountData?.state || ""}, ${accountData?.pincode || ""}</p>
            <p>Email: ${accountData?.email || "N/A"} | Phone: ${accountData?.mobile || "N/A"}</p>
            ${invoiceData?.gstNumber ? `<p>GSTIN: ${invoiceData.gstNumber}</p>` : ""}
            ${accountData?.fssaiNumber ? `<p>FSSAI: ${accountData.fssaiNumber}</p>` : ""}
            <div class="line"></div>

            <p><b>Invoice No:</b> ${invoiceData?.code || "N/A"}</p>
            <p><b>Date:</b> ${invoiceDate}</p>
            <p><b>Customer:</b> ${invoiceData?.customerName || "N/A"}</p>
            <p><b>Phone:</b> ${invoiceData?.customerPhone || "N/A"}</p>
            <div class="line"></div>

            <div class="item-row" style="font-weight:bold;">
              <div class="item-name">Item</div>
              <div class="item-qty">Qty</div>
              <div class="item-price">Rate</div>
              <div class="item-total">Total</div>
            </div>
            <div class="line"></div>
            ${itemsHTML}
            <div class="line"></div>

            <div class="totals"><span>Subtotal:</span><span>₹${invoiceData?.subTotal}</span></div>
            <div class="totals"><span>GST:</span><span>₹${totalGST}</span></div>
            <div class="totals"><span>Grand Total:</span><span>₹${invoiceData?.grandTotal}</span></div>
            <div class="line"></div>

            <p>Thank you for your purchase!</p>
          </div>
          <script>
            window.onload = () => {
              window.print();
            };
          </script>
        </body>
      </html>
    `;

    const blob = new Blob([htmlContent], { type: "text/html" });
    const blobURL = URL.createObjectURL(blob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = blobURL;
    document.body.appendChild(iframe);

    const cleanup = () => {
      document.body.removeChild(iframe);
      URL.revokeObjectURL(blobURL);
      window.removeEventListener("focus", cleanup);
    };
    window.addEventListener("focus", cleanup);
  };

  return (
    <button
      className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 mr-2"
      type="button"
      onClick={handlePrint}
    >
      Print
    </button>
  );
};

export default ThermalInvoice;
